<template>
    <GetStartedLayout
        class="white"
        :errors="errors"
        title="Amazing!"
        :subtitle="`We've sent an email to ${this.guest.email} with next steps`"
        :guest="guest"
        :needHelp="false"
        ><v-container style="min-height: 50vh">
            <v-row
                ><v-col cols="12" sm="8" md="6" class="mx-auto">
                    <v-card
                        class="mx-auto soli-round"
                        style="border: none; max-width: 500px"
                    >
                        <v-img
                            src="/four-guitars.webp"
                            height="200px"
                            position="top"
                        ></v-img>

                        <v-container class="px-4 text-align-center">
                            <v-card-title class="soli-grey">
                                Students who start lessons with a friend are
                                more motivated and make more progress
                            </v-card-title>
                            <v-card-subtitle class="subtitle-1 soli-grey pt-2">
                                Who do you know who might want to take lessons
                                with you?
                            </v-card-subtitle>

                            <v-card-actions>
                                <v-btn
                                    @click="share()"
                                    color="accent"
                                    large
                                    rounded
                                    outlined
                                    block
                                >
                                    Share<v-icon>share</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card>
                    <div class="my-6 flex flex-col">
                        <v-card-subtitle
                            class="subtitle-1 pb-0 text-align-center"
                            >Happy music-making!</v-card-subtitle
                        >
                        <v-card-subtitle
                            class="pt-0 subtitle-1 text-align-center"
                            >Team Musicologie</v-card-subtitle
                        >
                    </div>
                </v-col></v-row
            >
        </v-container>
    </GetStartedLayout>
</template>

<script>
import GetStartedLayout from "../../Layouts/GetStartedLayout.vue";
import VueLottiePlayer from "vue-lottie-player";
import confetti from "canvas-confetti";

export default {
    components: {
        GetStartedLayout,
        VueLottiePlayer,
    },
    props: ["errors", "guest", "lesson"],
    data() {
        return {
            lottieSrc:
                "https://assets9.lottiefiles.com/private_files/lf30_4fmeymz1.json",
            //"https://assets2.lottiefiles.com/private_files/lf30_xnjjfyjt.json",
        };
    },
    methods: {
        share() {
            if (navigator.share) {
                let path = "";
                if (this.guest.location.isOpen === false)
                    path = "-founders.html";

                navigator.share({
                    text: "I just signed up for music lessons at Musicologie! Would you like to join me?",
                    url: `https://go.musicologie.com${path}?utm_source=checkout_share`,
                });
            }
        },
    },
    mounted() {
        /*if (document.querySelector("#lottie")) return;
        let lottie = document.createElement("script");
        lottie.setAttribute(
            "src",
            "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"
        );
        lottie.id = "lottie";
        document.head.appendChild(lottie);*/
        confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 },
        });
    },
};
</script>
